import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface TriangleToggleProps {
  toggleLabel: string;
  children: JSX.Element;
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
}

export default function TriangleToggle(props: TriangleToggleProps): JSX.Element {
  return (
    <>
      <div
        onClick={() => {
          props.setIsCollapsed(!props.isCollapsed);
        }}
        className={classNames(css(styles.toggleLabel), 'u-mini-spacing-top')}
      >
        <CollapsibleTriangle isCollapsed={props.isCollapsed} />
        {props.toggleLabel}
      </div>
      {!props.isCollapsed && props.children}
    </>
  );
}

export interface CollapsibleTriangleProps {
  isCollapsed: boolean;
}

export function CollapsibleTriangle(props: CollapsibleTriangleProps): JSX.Element {
  if (props.isCollapsed) {
    return <BenchlingIcon className={css(styles.toggleIcon)} icon="triangle-right" />;
  } else {
    return <BenchlingIcon className={css(styles.toggleIcon)} icon="triangle-down" />;
  }
}

const styles = StyleSheet.create({
  toggleIcon: {
    color: Colors.GRAY_DARKER,
    marginRight: 6,
    flex: 'none',
  },
  toggleLabel: {
    cursor: 'pointer',
  },
});
